import { Box, Grid, Heading, Text } from "@chakra-ui/react";
import { RichText, RouteMeta } from "@/components";
import { ACCESSIBILITY, ACCESSIBILITY_META } from "@/content";
import { DiscordCta, Footer, Nav, Section, SkipLink } from "@/layout";
import { BackLink } from "@/sections";

export const AccessibilityPage = () => (
  <>
    <RouteMeta meta={ACCESSIBILITY_META} />
    <SkipLink />
    <Nav />
    <Box as="main" id="main">
      <Grid
        as="section"
        maxW="maxw"
        mx="auto"
        px="pad"
        pt="clamp(48px, 7vw, 104px)"
        pb="clamp(40px, 5vw, 72px)"
        gap="22px"
        justifyItems="center"
        textAlign="center"
      >
        <Text variant="eyebrowBrand">{ACCESSIBILITY.eyebrow}</Text>
        <Heading as="h1" variant="section" maxW="16ch">
          {ACCESSIBILITY.title}
        </Heading>
        <Text variant="lede" maxW="54ch">
          {ACCESSIBILITY.intro}
        </Text>
      </Grid>
      <Section maxW="860px" display="grid" gap="18px">
        <Heading as="h2" variant="card">
          {ACCESSIBILITY.commitmentsLabel}
        </Heading>
        <Grid as="ul" role="list" gap="12px">
          {ACCESSIBILITY.commitments.map((commitment) => (
            <Text as="li" variant="body" key={commitment}>
              {commitment}
            </Text>
          ))}
        </Grid>
        <Heading as="h2" variant="card" mt="clamp(24px, 3vw, 40px)">
          {ACCESSIBILITY.feedbackLabel}
        </Heading>
        <Text variant="body">
          <RichText nodes={ACCESSIBILITY.feedback} />
        </Text>
        <Text variant="small">{ACCESSIBILITY.reviewed}</Text>
      </Section>
      <BackLink />
      <DiscordCta />
    </Box>
    <Footer />
  </>
);
